//= ========================================================================
import React from 'react';
import FullPageSimulator from '../../FullPageSimulator';
import AccountBalance from '../../../AuxiliaryComponent/AmountSim/AccountBalance';
import AmountComponent from '../../../AuxiliaryComponent/AmountSim/AmountComponent';

const AmountMenuFP = ({
  globJSON,
  simPlatform,
  amount,
  priceAmount,
  showConvert,
  IconBackgroundColor = globJSON.configurations.theme.colors.disabled_cta_color,
  showExpendBox,
  amountColor = globJSON.configurations.theme.colors.primary_font_color,
  colorText = globJSON.configurations.theme.colors.secondary_font_color, isMenu, isErroLine,
  strTitle = '',
  enable_select_currency,
  slideshowRefs = null,
  isLoan,
}) => (
  <FullPageSimulator
    globJSON={globJSON}
    simPlatform={simPlatform}
    headlineText={isLoan ? amount.enter_loan_amount : amount.how_much_to_transfer}
    keyboardType="numbersKeyboard"
    TopTitle={strTitle}
    slideshowRefs={slideshowRefs}
  >
    {(amount.show_account_balance || isMenu) && !isLoan
        && (
        <AccountBalance
          globJSON={globJSON}
          showExpendBox={showExpendBox}
        />
        )}
    <AmountComponent
      globJSON={globJSON}
      IconBackgroundColor={IconBackgroundColor}
      priceAmount={priceAmount}
      amountColor={amountColor}
      colorText={colorText}
      showConvert={showConvert}
      isErrorLine={isErroLine}
      enable_select_currency={enable_select_currency}
      showAccountBalance={amount.show_account_balance}
    />
  </FullPageSimulator>
);

export default AmountMenuFP;
